import React, { useContext } from "react";
var FormContext = /*#__PURE__*/React.createContext();
export var FormProvider = FormContext.Provider;

function useForm(componentName) {
  var context = useContext(FormContext);

  if (context) {
    return context;
  }

  throw new Error("".concat(componentName, " must be placed inside a Form"));
}

export default useForm;